import React from "react";
import { motion } from "framer-motion";
import { Overline } from "./Reveal";

export const PageHero = ({ overline, title, highlight, desc, image }) => (
  <section className="relative pt-36 sm:pt-44 pb-16 sm:pb-24 px-4 sm:px-8 lg:px-16 overflow-hidden" data-testid="page-hero">
    {image && (
      <>
        <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#05070A]/70 via-[#05070A]/90 to-[#05070A]" />
      </>
    )}
    <div className="absolute inset-0 grid-overlay opacity-60 pointer-events-none" />
    <div className="relative max-w-7xl mx-auto">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
        <Overline>{overline}</Overline>
      </motion.div>
      <motion.h1
        initial={{ opacity: 0, y: 36 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.75, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
        className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.06] text-white mt-4 max-w-4xl"
      >
        {title} {highlight && <span className="text-cyan-400 text-glow-cyan">{highlight}</span>}
      </motion.h1>
      {desc && (
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.22 }}
          className="mt-6 text-base sm:text-lg text-slate-300 leading-relaxed max-w-2xl"
        >
          {desc}
        </motion.p>
      )}
    </div>
  </section>
);
